import { MarketingPublicationInteractionRequest } from './marketingPublicationInteraction.types';
import api from '@/api';
import { API_BASE_URL } from '..';

const CONTROLLER_URL = `${API_BASE_URL}/marketingPublicationInteraction`;

const marketingPublicationInteractionService = {
  async postMarketingPublicationInteraction(
    marketingPublication: MarketingPublicationInteractionRequest,
  ) {
    const { id, ...rest } = marketingPublication;

    const result = (await api.post(`${CONTROLLER_URL}/${id}`, {
      ...rest,
    })) as unknown;

    return result;
  },
};

export default marketingPublicationInteractionService;
